const group = state => state.group
const groups = state => state.groups

export default {
  group,
  groups

}
